import { render, staticRenderFns } from "./CardMultipleCol.vue?vue&type=template&id=10c1f6b8"
import script from "./CardMultipleCol.vue?vue&type=script&lang=js"
export * from "./CardMultipleCol.vue?vue&type=script&lang=js"
import style0 from "./CardMultipleCol.vue?vue&type=style&index=0&id=10c1f6b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports